import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createMigrate, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rtkQueryErrorLogger } from './middleware/errorLogging';
import rootReducer from './rootReducer';
import { api } from './services/api';

export const history = createBrowserHistory();

const persistConfig = {
    key: 'root',
    storage: storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat([api.middleware, rtkQueryErrorLogger]),
    devTools: true,
});

export type AppDispatch = typeof store.dispatch;
